<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="useBtnList"
                    @btnRetrieve="btnRetrieve()" @btnPrint="btnPrint()" @btnSaveExcel="btnSaveExcel()"
                  >
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-2 pb-0">
                        <i-label :label="'Ship No : '"/>
                        <v-col cols="1">
                          <v-select
                            v-model="shipNo"
                            :items="shipNoList"
                            item-value="shipNo"
                            return-object
                            single-line
                            outlined
                            dense
                            @change="btnRetrieve"
                          ></v-select>
                        </v-col>
                        <i-label :label="'M-ACT : '" class="pl-2"/>
                        <v-col cols="3" >
                          <v-select
                            v-model="mAct"
                            :items="mActList"
                            item-value="mAct"
                            return-object
                            single-line
                            outlined
                            dense
                            @change="btnRetrieve"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms6500" 
                    :ref="epms6500Ref"
                    class="hipGridHeight1_1"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="false"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                    :word-wrap-enabled="true"
                    @cellPrepared="cellPrepared"
                  >
                    <DxColumn data-field="rnum" caption="No" width="3%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>  
                    <DxColumn data-field="shipNo" caption="Ship" width="6%" data-type="string" alignment="center" :allow-editing="false"/>  
                    <DxColumn caption="Por No" width="6%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="porNo" caption="SEQ" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn data-field="partSpec" caption="Part Spec" width="12%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn caption="Part No" width="6%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="partNo" caption="Unit" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn data-field="block" caption="Block" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="mact" caption="M.ACT" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="partQty" caption="Qty" width="3%" data-type="string" alignment="right" :allow-editing="false"/>
                    <DxColumn caption="POR Iss.DT" width="6%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="porIssueDte" caption="PO Date" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn caption="KAS Date" width="6%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="kasWhDte" caption="Shp.Date" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn caption="W/H Req.DT" width="6%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="whReqDte" caption="W/H Date" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn data-field="makerNm" caption="Maker Name" width="12%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="hvsPicNm" caption="HVS PIC" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="issueDte" caption="Iss Date" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn caption="Iss Emp" width="6%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="issEmp" caption="Req Dept" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxPaging :enabled="true" :page-size="18" />
                  </DxDataGrid>
                </v-col>
              </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getShipList } from '@/api/view/hip/6/epms6400.js'
import { getmActList , epms6500List , epms6500Xls } from '@/api/view/hip/6/epms6500.js'
import { reportView} from '@/api/view/hip/common/common.js'

export default {
  name: 'epms6500',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve' , 'btnPrint' , 'btnSaveExcel'],
      epms6500Ref: 'epms6500Ref',
      gridMainList: [],

      shipNo: '',
      shipNoList: [],
      revNo: '',
      mAct: '',
      mActList: [],

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms6500Ref)
    },
  },
  mounted() {
    this.getList()
    this.gridMainInstance.option('defaultPaging', false)
  },
  methods: {
    async getList(){
      try {
        this.openLoading('searching')
        let params = {
          makerCd: this.$store.state.user.makerCd,
        }
        await getShipList(params).then(res => {
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
        })

        await getmActList(params).then(res => {
          res.list.forEach(e => {
            this.mActList.push(e.mact + ' : ' + e.actNm)
          });
          this.mAct = this.mActList[0]
        })

      } finally {
      this.endLoading()
      }
    },
    async getMainList(){
      try {
        this.openLoading('searching')
        let mactGbn = this.mAct
        mactGbn = mactGbn.split(' : ')
        let params = {
          shipNo: this.shipNo,
          mact: mactGbn[0],
        }
        await epms6500List(params).then(res => {
          let list = []
          let cnt = 1;
          res.list.forEach(e => {
            list.push(
              {
                id: cnt++ , rnum: e.rnum, shipNo: e.shipNo, porNo: e.porNo, partSpec: e.partSpec, partNo: e.partNo, block: e.block, mact: e.mact,
                partQty: e.partQty, porIssueDte: e.porIssueDte, kasWhDte: e.kasWhDte, whReqDte: e.whReqDte, makerNm: e.makerNm,
                hvsPicNm: e.hvsPicNm, issueDte: e.issueDte, issEmp: e.issEmp
              },
              {
                id: cnt++ , rnum: e.rnum, shipNo: e.shipNo, porNo: e.porSeq, partSpec: e.partSpec, partNo: e.matlUnit, block: e.block, mact: e.mact,
                partQty: e.partQty, porIssueDte: e.poDte, kasWhDte: e.shippingDte, whReqDte: e.whDte, makerNm: e.makerNm,
                hvsPicNm: e.hvsPicNm, issueDte: e.issueDte, issEmp: e.issDept
              }
            )
          });
          this.gridMainList = list
        })

      } finally {
      this.endLoading()
      }
    },
    btnRetrieve(){
      this.gridMainList = []
      this.getMainList()
    },
    btnPrint(){
      let mactGbn = this.mAct
      mactGbn = mactGbn.split(' : ')
      const param = {
        fileName: 'epms6500prt.jrxml',
        as_ship_no: this.shipNo,
        as_m_act: mactGbn[0],
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnSaveExcel(){
      let mactGbn = this.mAct
      mactGbn = mactGbn.split(' : ')
      const param = {
        shipNo: this.shipNo,
        mact: mactGbn[0]
      }
      epms6500Xls(param)
    },
    //cell merge
    cellPrepared(e){
      if(e.rowType === 'data'){
        if(e.column.caption === 'No' || e.column.caption === 'Ship' || e.column.caption === 'Part Spec' || e.column.caption === 'Block' || e.column.caption === 'M.ACT' 
          || e.column.caption === 'Qty' || e.column.caption === 'Maker Name' || e.column.caption === 'HVS PIC' || e.column.caption === 'Iss Date'){
          if(e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'rnum')){
            e.cellElement.setAttribute('rowspan', 2)
          }else {
            e.cellElement.style.display = 'none'
          }
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
</style>